import { Component, OnDestroy, OnInit, } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Category } from "../core/models/category.model";
import { DocumentService } from "./shared";


@Component({
  selector: 'bp-docs',
  templateUrl: 'documents.component.html'
})
export class DocumentsComponent implements OnInit, OnDestroy {
  categories: Category[] = [];

  private id: any;

  constructor(
    private documentService: DocumentService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    this.getCategories();
  }

  ngOnDestroy() {

  }

  getCategories() {
    this.categories = [];

    this.documentService.getCategories()
      .subscribe(categories => {
        this.categories = categories;
        let initSelection = this.categories && this.categories.length > 0 && this.categories[0].id;
        this.router.navigateByUrl(`/documents/${initSelection}`);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/documents/documents.component.ts